import { NewsCenter, PublicLocale } from "../../../types";
import { NewsCenterActionTypes, SET_INITIAL_STATE, SET_LOCALE } from "./types";

export function setInitialState(newsCenter: NewsCenter): NewsCenterActionTypes {
  return {
    type: SET_INITIAL_STATE,
    newsCenter: newsCenter,
  };
}

export function setLocale(locale: PublicLocale): NewsCenterActionTypes {
  return {
    type: SET_LOCALE,
    locale: locale,
  };
}
